// ─── DevOps · Valoraciones (GHE #1125) ───
//
// 🚨 ESTE FICHERO ES UN LAYOUT, NO UNA PÁGINA. Desde que existe `devops.$clienteRef.tsx`,
// TanStack lo trata como el padre de esa ruta, y un layout que pinta contenido en vez de un
// `<Outlet/>` se traga en SILENCIO todas sus rutas hijas — el cliente dejaría de ser alcanzable
// sin ningún error. Es la trampa que `dashboards.tsx` documenta y que aquí se repite igual.
//
// La lista de clientes vive en `devops.index.tsx`; un cliente concreto en `devops.$clienteRef.tsx`.
//
// El esquema de búsqueda se queda AQUÍ, en el padre, para que lo hereden las dos: es lo que
// mantiene vivas las URL antiguas `?cliente=<uuid>` mientras el índice las redirige.

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

export const devopsSearchSchema = z.object({
  /**
   * Cliente de PLANI que se está mirando, en la forma ANTIGUA.
   *
   * ⚠️ Conservado sólo por compatibilidad: la dirección canónica es ahora
   * `/app/devops/{slug}-{short}` y el índice redirige a ella. No lo uses para enlazar — para eso
   * está `clientPath()`. Se mantiene porque el dueño pidió no romper marcadores ya guardados
   * (2026-09-14), y borrarlo convertiría cada enlace enviado por chat en un «no encontrado».
   *
   * `.catch(undefined)` como en el resto de la casa: un enlace manipulado degrada a «sin cliente»
   * en vez de reventar la ruta.
   */
  cliente: z.string().uuid().optional().catch(undefined),
});

function DevOpsLayout(): React.ReactElement {
  return <Outlet />;
}

export const Route = createFileRoute('/app/devops')({
  validateSearch: devopsSearchSchema,
  component: DevOpsLayout,
});
